import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../stores/store';
import { HeaderBtn, HeaderBtnContent } from '../header-btn/header-btn.styles';
import {
  HeaderNavContainer,
  UserAvatar,
  UserNavMobileContainer,
  ActionsDesktop,
} from './header-user.styles';
import NavUserMenu from './header-user-menu.component';
import { Dropdown } from '../../../common/dropdown/dropdown.styles';
import Button from '../../../common/button/button.component';
import { useStartParcelCreation } from '../../../hooks/use-start-parcel-creation.hook';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '../../../common/popover/popover.component';
import { testIds } from '../../../../test-ids';
import { useIsMobile } from '../../../hooks/use-is-mobile.hook';

interface Props {
  isMainPage: boolean;
}

const NavUser = ({ isMainPage }: Props) => {
  const {
    userStore: { getInitials },
    navStore: {
      toggleLeftSidebar,
      isLeftSidebarOpened,
      isNavbarPopupOpened,
      toggleNavbarPopupOpened,
    },
    commonStore: { analyticsManager },
  } = useStore();

  const handleStartParcelCreation = useStartParcelCreation();
  const { t } = useTranslation();

  const isMobile = useIsMobile();

  return (
    <>
      {!isMobile && (
        <ActionsDesktop>
          {isMainPage && (
            <Button
              testId={testIds.header.newParcel}
              fullWidth={false}
              onClick={() => {
                analyticsManager.track('start_new_delivery');
                handleStartParcelCreation();
              }}>
              {t('create_parcel')}
            </Button>
          )}
          <Popover
            initialOpen={isNavbarPopupOpened}
            open={isNavbarPopupOpened}
            onOpenChange={toggleNavbarPopupOpened}
            placement='bottom-end'>
            <PopoverTrigger asChild>
              <HeaderBtn
                onClick={toggleNavbarPopupOpened}
                aria-expanded={isNavbarPopupOpened}
                data-testid={testIds.header.avatar}>
                <HeaderBtnContent>
                  <UserAvatar>{getInitials()}</UserAvatar>
                </HeaderBtnContent>
              </HeaderBtn>
            </PopoverTrigger>
            <PopoverContent>
              <HeaderNavContainer data-testid={testIds.header.userMenu}>
                <Dropdown $width='27.2rem'>
                  <NavUserMenu />
                </Dropdown>
              </HeaderNavContainer>
            </PopoverContent>
          </Popover>
        </ActionsDesktop>
      )}

      {isMobile && (
        <UserNavMobileContainer>
          <HeaderBtn
            onClick={toggleLeftSidebar}
            aria-expanded={isLeftSidebarOpened}
            data-testid={testIds.header.avatar}>
            <HeaderBtnContent>
              <UserAvatar>{getInitials()}</UserAvatar>
            </HeaderBtnContent>
          </HeaderBtn>
        </UserNavMobileContainer>
      )}
    </>
  );
};

export default observer(NavUser);
